// extracted by mini-css-extract-plugin
export default {"labelAndCheckbox":"Options_labelAndCheckbox__gAJom","innerDiv":"Options_innerDiv__WtPt+"};